var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "both-pd-box1" },
    [
      _c("h3", [_vm._v("推送消息记录")]),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _c("div", { staticClass: "search_criteria" }, [
        _c(
          "div",
          { staticStyle: { "margin-left": "0" } },
          [
            _c("el-input", {
              attrs: { placeholder: "输入消息ID查询", clearable: "" },
              model: {
                value: _vm.queryData.messagePlanConfigId,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "messagePlanConfigId", $$v)
                },
                expression: "queryData.messagePlanConfigId",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-select",
              {
                staticStyle: { width: "100%" },
                attrs: { clearable: "", placeholder: "请选择消息类型" },
                model: {
                  value: _vm.queryData.messageType,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "messageType", $$v)
                  },
                  expression: "queryData.messageType",
                },
              },
              [
                _c("el-option", {
                  attrs: { value: "ACTIVITY_MESSAGE", label: "活动消息" },
                }),
                _vm._v(" "),
                _c("el-option", {
                  attrs: { value: "SYSTEM_MESSAGE", label: "系统消息" },
                }),
                _vm._v(" "),
                _c("el-option", {
                  attrs: { value: "ORDER_MESSAGE", label: "订单消息" },
                }),
                _vm._v(" "),
                _c("el-option", {
                  attrs: { value: "WITHDRAW_MESSAGE", label: "提现消息" },
                }),
                _vm._v(" "),
                _c("el-option", {
                  attrs: { value: "FAN_MESSAGE", label: "粉丝消息" },
                }),
                _vm._v(" "),
                _c("el-option", {
                  attrs: { value: "SETTLE_MESSAGE", label: "结算消息" },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-select",
              {
                staticStyle: { width: "100%" },
                attrs: { clearable: "", placeholder: "请选择发送状态" },
                model: {
                  value: _vm.queryData.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "status", $$v)
                  },
                  expression: "queryData.status",
                },
              },
              [
                _c("el-option", { attrs: { value: 0, label: "待发送" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: 1, label: "发送成功" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: 2, label: "发送失败" } }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("el-input", {
              attrs: { placeholder: "输入会员ID查询", clearable: "" },
              model: {
                value: _vm.queryData.memberId,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "memberId", $$v)
                },
                expression: "queryData.memberId",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex",
            staticStyle: { width: "fit-content", height: "40px" },
          },
          [
            _c(
              "el-button",
              {
                staticStyle: { height: "40px" },
                attrs: { type: "primary" },
                on: { click: _vm.onInquire },
              },
              [_vm._v("查询")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "ml10",
                staticStyle: { height: "40px" },
                attrs: { type: "info", plain: "" },
                on: { click: _vm.onInitialize },
              },
              [_vm._v("重置")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt20" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                border: "",
                data: _vm.tableData,
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "消息配置ID",
                  align: "center",
                  prop: "messagePlanConfigId",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.messagePlanConfigId || "-") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "消息类型 ", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.messageType) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "用户ID", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "pointer",
                            staticStyle: {
                              "font-size": "14px",
                              color: "#4d8aff",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onUserDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.nickName))]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v("uid:" + _vm._s(scope.row.memberId)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "messageTittle",
                  label: "通知标题",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  "min-width": "300",
                  prop: "messageContent",
                  label: "通知内容",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "推送状态", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === 0
                          ? _c("div", { staticStyle: { color: "#f39c12" } }, [
                              _vm._v("待发送（等待队列）"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 1
                          ? _c("div", { staticStyle: { color: "#67c23a" } }, [
                              _vm._v("发送成功"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 2
                          ? _c("div", { staticStyle: { color: "#f56c6c" } }, [
                              _vm._v("发送失败"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "发送时间 ",
                  align: "center",
                  prop: "pushTime",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "remark", label: "操作", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === 2
                          ? _c(
                              "div",
                              { staticClass: "fc" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onReissue(
                                          scope.row.messageRecordId
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("重发")]
                                ),
                              ],
                              1
                            )
                          : _c("div", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt20 page_box" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryData.page,
              "page-sizes": [10, 20, 30, 40],
              "page-size": _vm.queryData.size,
              layout: "total, prev, pager, next, sizes,jumper",
              total: _vm.total,
              background: "",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }